import * as React from 'react';
import { LayoutContext } from './LayoutContext';
import useWindowDimensions from '../../../utils/WindowDimensionHook';
function LayoutProvider(props) { var _React$useState = React.useState(true), isProfileExpanded = _React$useState[0], setExpanded = _React$useState[1]; var persistProfileExpand = function persistProfileExpand() { setExpanded(!isProfileExpanded); }; var _useWindowDimensions = useWindowDimensions(), height = _useWindowDimensions.height, width = _useWindowDimensions.width; React.useEffect(function () { if (width < 992 && width !== 0) {
    setExpanded(false);
}
else if (width >= 992 && !isProfileExpanded) {
    setExpanded(true);
} }, [width]); return /*#__PURE__*/ React.createElement(LayoutContext.Provider, { value: { isProfileExpanded: isProfileExpanded, expandProfile: function expandProfile() { return persistProfileExpand(); } } }, props.children); }
export default LayoutProvider;
